import { useCallback } from 'react'
import {
  BookableShipmentSearchQueryParams,
  useBookableShipmentSearch,
} from 'apps/fleet-planner/types'

export const useBookableShipmentAuctionSearch = () => {
  const { data, loading: isLoading, refetch } = useBookableShipmentSearch({
    lazy: true,
    queryParamStringifyOptions: {
      encodeValuesOnly: true,
      arrayFormat: 'brackets',
    },
  })
  const { totalCount = 0, auctionShipments = [] } = data || {}
  /**
   * Get auction shipments list
   */
  const getBookableAuctionShipments = useCallback(
    async (queryParams: BookableShipmentSearchQueryParams) => {
      try {
        await refetch({ queryParams })
      } catch (e) {
        // no-op
      }
    },
    [refetch]
  )
  return {
    getBookableAuctionShipments,
    totalCount,
    isLoading,
    auctionShipments,
  }
}
